import { Heading, Text } from '@bq/web-components';

export function AboutPage() {
  return (
    <main style={{ padding: 'var(--bq-vt-large) var(--bq-page-padding)' }}>
      <Heading level={2}>About BlueQueue</Heading>
      <Text size="r2" color="n700">
        Extended about page coming soon.
      </Text>
    </main>
  );
}
